import React, { useEffect, useReducer, useRef } from 'react';
import { useDispatch } from 'react-redux';

import InscricaoContext from '.';
import { get } from '../../../_axios/requisicao';
import { detectaDispositivo, getReferenciaPeloDominio, verificaPadraoHashLink } from '../../../_recursos/js/util';
import { useParams } from 'react-router-dom';
import { reducerConfigInscricao } from './reducer';

import { default as Erro404 } from '../../../paginas/Erro/_404'
import { default as Erro400 } from '../../../paginas/Erro/_400'
import Spinner from '../../../componentes/Spinner';

interface IRouterParams {
  hash?: string;
}

function InscricaoProvider({ children }: React.PropsWithChildren<{}>) {
  const { hash } = useParams<IRouterParams>()

  const dispatch = useDispatch()

  const refConfigRequisitado = useRef(false);
  const [config, dispatchConfig] = useReducer(reducerConfigInscricao, {})

  useEffect(() => {
    if (config.originResponse || config.originError) return;

    dispatch({ type: 'RESET_APP' });
    dispatch({ type: 'RESET_DADOS' });
    dispatch({ type: 'RESET_CONTATOS' });
    dispatch({ type: 'RESET_ENDERECO' });
    dispatch({ type: 'RESET_TERMOS' });
    dispatch({ type: 'RESET_VEREADOR' });
    dispatch({ type: 'RESET_VOLUNTARIO' });
    dispatch({ type: 'ALTERA_CARREGANDO', carregando: true });
    const hashOuVazio = hash ?? '';
    const hashValido = verificaPadraoHashLink(hashOuVazio);
    const referenciaValida = /^\d{4}[a-z]{2}$/.test(hashOuVazio)
    const referencia = (
      (hashValido && /^\d{4}[a-z]{2}/.test(hashOuVazio) && hash?.substring(0, 6))
      || (hashValido && ( /^bcom/.test(hashOuVazio) ? 'libcom' : 'arco' ))
      || (referenciaValida && hash)
      || (hashOuVazio === '' && getReferenciaPeloDominio())
      || undefined
    );

    if (!referencia) return dispatchConfig({ type: 'SET', payload: { originResponse: {} } });

    get('api-pessoas', `/inscricoes/${hashValido ? hash : ''}`, { referencia })
      .then((res) => {
        dispatchConfig({ type: 'SET', payload: { ...res.data, originResponse: res } })
        dispatch({ type: 'ALTERA_HASH', hash: hash ?? null });
        dispatch({ type: 'ALTERA_REFERENCIA', referencia })
        dispatch({
          type: 'ALTERA_TERMOS',
          termos: res.data.etapas.termos.map((t: any) => ({
            idTermo: t.idTermo,
            idTermoTipo: t.idTermoTipo,
            dispositivo: detectaDispositivo(),
            aceito: false,
          }))
        });
      })
      .catch((e) => {
        console.error(e)
        dispatchConfig({ type: 'SET', payload: { originError: e } });
      })
      .finally(() => {
        refConfigRequisitado.current = true;
        dispatch({ type: 'ALTERA_CARREGANDO', carregando: false })
      })
  }, [config.originError, config.originResponse, dispatch, hash])

  if (!config.originResponse && !config.originError) return <Spinner />
  if (config.originResponse && config.originResponse.status !== 200) return <Erro404 />
  if (config.originError) return config.originError.status === 404 ? <Erro404 /> : <Erro400 erro={config.originError?.error.code} />

  return (
    <InscricaoContext.Provider value={config}>
      {children}
    </InscricaoContext.Provider>
  )
}

export default InscricaoProvider;
